import { defineMessages } from 'react-intl'

export const subscriptionManagementMessages = defineMessages({
  title: {
    id: 'subscriptionManagement.title',
    description:
      'Header title for pages that manage/migrade/upgrade subscription',
    defaultMessage: 'Checkout',
  },
  totalToPay: {
    id: 'subscriptionManagement.totalToPay',
    description:
      'Total To Pay label for bottom panel on Subscription Management page',
    defaultMessage: 'Annual Total',
  },
  totalForSubscription: {
    id: 'subscriptionManagement.totalForSubscription',
    description:
      'Total For Subscription label for bottom panel on Subscription Management page',
    defaultMessage: 'Total annually',
  },
  freePrice: {
    id: 'subscriptionManagement.freePrice',
    description: 'Free price label',
    defaultMessage: 'Free',
  },
  yearlyPrice: {
    id: 'subscriptionManagement.yearlyPrice',
    description: 'Yearly price label',
    defaultMessage: '{price}/year',
  },
  monthlyPrice: {
    id: 'subscriptionManagement.monthlyPrice',
    description: 'Monthly price label',
    defaultMessage: '{price}/month',
  },
  proceedToUpgrade: {
    id: 'subscriptionManagement.proceedToUpgrade',
    description:
      'Bottom panel submit button label on Subscription Management page',
    defaultMessage: 'Upgrade',
  },
  proceedToDowngrade: {
    id: 'subscriptionManagement.proceedToDowngrade',
    description:
      'Bottom panel submit button label on Subscription Management page',
    defaultMessage: 'Downgrade',
  },
  enrolled: {
    id: 'subscriptionManagement.enrolled',
    description: 'Enrolled label for user plan on Subscription Management page',
    defaultMessage: '(Enrolled)',
  },
  activePlanLabel: {
    id: 'subscriptionManagement.activePlanLabel',
    description:
      'Active Plan label for right panel on Subscription Management page',
    defaultMessage: 'Active Plan',
  },
  currentlyPayingLabel: {
    id: 'subscriptionManagement.currentlyPayingLabel',
    description:
      'Currently paying label for right panel on Subscription Management page',
    defaultMessage: 'Currently paying',
  },
  nextBillingDateLabel: {
    id: 'subscriptionManagement.nextBillingDateLabel',
    description:
      'Next Billing Date label for right panel on Subscription Management page',
    defaultMessage: 'Next Billing Date',
  },
  activePlanBottomText: {
    id: 'subscriptionManagement.activePlanBottomText',
    description:
      'Active Plan bottom text for right panel on Subscription Management page',
    defaultMessage:
      'Upgrade subscription to have the best experience with Savant Essentials features.',
  },
  upgradePlanLabel: {
    id: 'subscriptionManagement.upgradePlanLabel',
    description:
      'Upgrade Plan label for right panel on Subscription Management page',
    defaultMessage: 'Upgrade Subscription',
  },
  upgradePlanBottomText: {
    id: 'subscriptionManagement.upgradePlanBottomText',
    description:
      'Upgrade Plan bottom text for right panel on Subscription Management page',
    defaultMessage:
      'Any applicable taxes will be calculated after checkout. Subscriptions are non-refundable. Transactions are in USD, and are subject to all applicable fees and currency exchange rates for the selected payment method. Any remaining credit will be applied before the selected payment method.',
  },
  downgradePlanInfoText: {
    id: 'subscriptionManagement.downgradePlanInfoText',
    description:
      'Downgrade Plan info text for right panel on Subscription Management page',
    defaultMessage:
      'You will have {currentPlanName} features available till expiration date. After this date you will have {selectedPlanName}',
  },
  expirationDate: {
    id: 'subscriptionManagement.expirationDate',
    description:
      'Expiration Date text for right panel on Subscription Management page',
    defaultMessage: 'Expiration date',
  },
  downgradePlanBottomText: {
    id: 'subscriptionManagement.downgradePlanBottomText',
    description:
      'Downgrade Plan bottom text for right panel on Subscription Management page',
    defaultMessage: 'Subscriptions are non-refundable.',
  },
  downgradeModalTitle: {
    id: 'subscriptionManagement.downgradeModalTitle',
    description: 'Downgrade modal title',
    defaultMessage: 'Downgrade subscription?',
  },
  downgradeModalBodyTextCurrentPlan: {
    id: 'subscriptionManagement.downgradeModalBodyTextCurrentPlan',
    description: 'Downgrade modal body text about current plan',
    defaultMessage:
      'This home subscription <b>{currentPlanName}</b> will end on date <b>{expirationDate}</b>',
  },
  downgradeModalBodyTextNextPlan: {
    id: 'subscriptionManagement.downgradeModalBodyTextNextPlan',
    description: 'Downgrade modal body text about next plan',
    defaultMessage:
      'Are you sure you want to cancel all subscriptions now and downgrade to <b>{selectedPlanName}</b>?',
  },
  downgradeModalCancelButton: {
    id: 'subscriptionManagement.downgradeModalCancelButton',
    description: 'Downgrade modal cancel button text',
    defaultMessage: 'No, Cancel',
  },
  downgradeModalSubmitButton: {
    id: 'subscriptionManagement.downgradeModalSubmitButton',
    description: 'Downgrade modal submit button text',
    defaultMessage: 'Yes, Downgrade',
  },

  addPaymentMethodSubmit: {
    id: 'subscriptionManagement.addPaymentMethodSubmit',
    description:
      'Bottom panel submit button label on Subscription Management - Add payment method page',
    defaultMessage: 'Next',
  },
  checkoutSubmit: {
    id: 'subscriptionManagement.checkoutSubmit',
    description:
      'Bottom panel submit button label on Subscription Management - Checkout page',
    defaultMessage: 'Pay Now & Subscribe',
  },

  default: {
    id: 'card.default',
    description: 'Text on a card saying that this card is default',
    defaultMessage: 'Default',
  },
  setAsDefault: {
    id: 'card.setDefault',
    description: 'Text on a button to set a payment card as default',
    defaultMessage: 'Make default',
  },
  expired: {
    id: 'card.expired',
    description: 'Text saying that card has expired',
    defaultMessage: 'Expired',
  },
  removePaymentMethodModal: {
    id: 'card.modalRemove',
    description: 'Remove payment card modal title',
    defaultMessage: 'Delete card {cardNumber}?',
  },
  setAsDefaultModal: {
    id: 'card.modalSetDefault',
    description: 'Make payment card default modal title',
    defaultMessage: 'Make default?',
  },
  cancel: {
    id: 'card.btnCancel',
    description: 'Cancel removing of payment card button text',
    defaultMessage: 'No, Keep',
  },
  yesRemove: {
    id: 'card.btnRemoveYes',
    description: 'Confirm removing of payment card button text',
    defaultMessage: 'Yes, Delete',
  },
  yesRemoveTransfer: {
    id: 'card.btnRemoveYesNotDefault',
    description: 'Confirm removing and transfer of payment card button text',
    defaultMessage: 'Yes, Delete & Transfer',
  },
  yesChange: {
    id: 'card.btnYesChange',
    description: 'Confirm "set payment method as default" operation',
    defaultMessage: 'Yes, Change',
  },
  removeText: {
    id: 'card.removeModalText',
    description: 'Text of modal for removing card',
    defaultMessage:
      'Deleting this payment method will transfer associated subscriptions to your default payment method. Are you sure you want to continue?',
  },
  removeDefaultCardText: {
    id: 'card.removeDefaultCardText',
    description: 'Text of modal for removing default card',
    defaultMessage:
      'Deleting this payment method will result in auto-renewal being cancelled for all currently enrolled subscriptions. In order to renew any active subscriptions, homes must be resubscribed to a new payment method. Are you sure you want to continue?',
  },
  removeDefaultCardWithSubscriptionText: {
    id: 'card.removeDefaultCardWithSubscriptionText',
    description: 'Text of modal for removing default card with subscription',
    defaultMessage:
      'The default payment method cannot be deleted when there are other payment methods on file. Before deleting this payment method, select a new default payment method using the “Make Default” option.',
  },
  removeDefaultCardWithoutSubscriptionText: {
    id: 'card.removeDefaultCardWithoutSubscriptionText',
    description: 'Text of modal for removing default card without subscription',
    defaultMessage:
      'Deleting this payment method will result in auto-renewal being cancelled for all currently enrolled subscriptions. In order to renew any active subscriptions, homes must be resubscribed to a new payment method. Are you sure you want to continue?',
  },
  removeDefaultCardByNotAdminText: {
    id: 'card.removeDefaultCardByNotAdminText',
    description:
      'Text of modal for removing default card by not an admin of the house',
    defaultMessage:
      'Deleting this payment method will result in auto-renewal being cancelled for all currently enrolled subscriptions. In order to renew any active subscriptions, homes must be resubscribed to a new payment method. Are you sure you want to continue?',
  },
  defaultText: {
    id: 'card.defaultModalText',
    description: 'Text of modal for making card as default',
    defaultMessage:
      'This card will be used for upcoming charges on your active subscriptions',
  },
  successText: {
    id: 'subscriptionManagement.successText',
    description: 'Text of modal for successful purchase',
    defaultMessage:
      'You have <bold>{planName}</bold> for home <bold>{homeName}</bold>.{br} The renewal date will be <bold>{nextBillingDate}</bold>.',
  },
  errorTitle: {
    id: 'subscriptionManagement.errorTitle',
    description: 'Error title of purchase subscription modal',
    defaultMessage: 'Error Occurred',
  },
  errorText: {
    id: 'subscriptionManagement.errorText',
    description: 'Error text of purchase subscription modal',
    defaultMessage:
      'The subscription update failed. Please try again using a different method of payment.',
  },
  paymentMethod: {
    id: 'subscriptionManagement.paymentMethods',
    description: 'Payment method text',
    defaultMessage: 'Payment method',
  },
  billedAnnualyText: {
    id: 'subscriptionManagement.billedAnnualyText',
    description: 'Billed annually text',
    defaultMessage: 'Billed Annually',
  },
})
